import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = { class: "card success-card" }
const _hoisted_3 = { class: "card-body text-center py-5" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 1,
  class: "error-container"
}
const _hoisted_7 = { class: "text-muted mb-4" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = {
  key: 2,
  class: "success-container"
}
const _hoisted_10 = { class: "success-details mb-4" }
const _hoisted_11 = { class: "lead mb-4" }
const _hoisted_12 = { class: "info-cards" }
const _hoisted_13 = { class: "info-card" }
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = { class: "info-card" }
const _hoisted_16 = { class: "info-value" }
const _hoisted_17 = { class: "info-card" }
const _hoisted_18 = { class: "info-value" }
const _hoisted_19 = { class: "action-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("div", {
                class: "spinner-border text-primary mb-3",
                style: {"width":"3rem","height":"3rem"}
              }, null, -1)),
              _createElementVNode("h4", null, _toDisplayString(_ctx.loadingTitle), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.retryMessage), 1)
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon-wrapper error-icon mb-4" }, [
                  _createElementVNode("i", { class: "fas fa-exclamation-circle" })
                ], -1)),
                _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "mb-3" }, "Une erreur est survenue", -1)),
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.error), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retryVerification && _ctx.retryVerification(...args))),
                    class: "btn btn-primary me-3"
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "fas fa-redo me-2" }, null, -1),
                    _createTextVNode(" Réessayer ", -1)
                  ]))]),
                  _createVNode(_component_router_link, {
                    to: "/liste-besc",
                    class: "btn btn-outline-secondary"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1),
                      _createTextVNode(" Retour à la liste ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "icon-wrapper success-icon mb-4" }, [
                  _createElementVNode("i", { class: "fas fa-check-circle" })
                ], -1)),
                _cache[17] || (_cache[17] = _createElementVNode("h2", { class: "mb-3" }, "Paiement réussi !", -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createTextVNode(" Votre BESC ", -1)),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.refbesc), 1),
                    _cache[7] || (_cache[7] = _createTextVNode(" a été payé avec succès et soumis pour validation. ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-credit-card mb-2" }, null, -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "info-label" }, "Moyen de paiement", -1)),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.paymentMethodLabel), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-file-invoice-dollar mb-2" }, null, -1)),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "info-label" }, "Référence", -1)),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.refbesc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[12] || (_cache[12] = _createElementVNode("i", { class: "fas fa-clock mb-2" }, null, -1)),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "info-label" }, "Statut", -1)),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.getStatusClass(_ctx.bescStatus?.code))
                        }, _toDisplayString(_ctx.bescStatus?.label || '—'), 3)
                      ])
                    ])
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "alert alert-info mt-4" }, [
                    _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                    _createTextVNode(" Votre BESC sera traité par nos équipes dans les plus brefs délais. Vous recevrez une notification par email. ")
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: "/liste-besc",
                    class: "btn btn-primary btn-lg"
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("i", { class: "fas fa-list me-2" }, null, -1),
                      _createTextVNode(" Retourner à la liste de mes BESCs ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]))
      ])
    ])
  ]))
}